"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Avatar_1 = __importDefault(require("../../Avatar"));
var config_1 = require("../../config");
var Icon_1 = __importDefault(require("../../Icon"));
var HeaderMenu = /** @class */ (function (_super) {
    __extends(HeaderMenu, _super);
    function HeaderMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onMenuItemClick = function (e) {
            var id = e.currentTarget.getAttribute("data-id");
            if (id) {
                _this.props.onChange(id);
            }
        };
        return _this;
    }
    HeaderMenu.prototype.render = function () {
        var _this = this;
        var _a = this.props, items = _a.items, active = _a.active, className = _a.className, imageUrl = _a.imageUrl, icon = _a.icon;
        var b = config_1.block("headermenu");
        var menuItems = items.map(function (item) {
            return (react_1.default.createElement("li", { key: "item-" + item.id, className: b("submenu__item", { active: item.id === active }) },
                react_1.default.createElement("a", { "data-id": item.id, onClick: _this.onMenuItemClick }, item.label)));
        });
        return (react_1.default.createElement("div", { className: b({}).mix(className) },
            icon ? react_1.default.createElement(Icon_1.default, __assign({}, icon)) : react_1.default.createElement(Avatar_1.default, { uri: imageUrl, size: 32 }),
            react_1.default.createElement("ul", { className: b("submenu") }, menuItems)));
    };
    return HeaderMenu;
}(react_1.default.Component));
exports.default = HeaderMenu;
//# sourceMappingURL=index.js.map